// api/apiClient.js - Merkezi API istemcisi
import axios from 'axios';

// API temel URL'ini göreceli yol olarak ayarla
const API_URL = '/api';

// Axios instance oluştur
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  // SSL sertifika doğrulamasını yapma (güvenli olmayan bağlantılar için)
  withCredentials: false
});

// İstek interceptor'ü - her istekte token ekle
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Yanıt interceptor'ü - hata işleme
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error('API Error:', error.response || error);
    
    const message = 
      error.response?.data?.message || 
      error.message || 
      'Bir hata oluştu';
    
    // 401 Unauthorized - token süresi doldu vs.
    if (error.response?.status === 401) {
      // Sadece /auth/login değilse token'ı sil ve login sayfasına yönlendir
      if (!error.config.url.includes('/auth/login')) {
        console.log('Yetkilendirme hatası, oturum sonlandırılıyor');
        localStorage.removeItem('token');
        // Sayfayı yenileme yerine yönlendirme kullan
        // window.location.href = '/login';
      }
    }
    
    return Promise.reject(new Error(message));
  }
);

export default apiClient; 